export default "__VITE_ASSET__4X1kPREW__"